import * as React from "react";
import * as s from "./DropdownMenu.style.css";

export const MenuDivider = () => <hr className={s.menuDivider} role="separator" aria-orientation="horizontal" />;
MenuDivider.displayName = "MenuDivider";
